import HomePage from './pages/HomePage';
import ImpureChessPrivacyPolicyPage from './pages/ImpureChessPrivacyPolicyPage';
import ImpureChessTermsAndConditionsPage from './pages/ImpureChessTermsAndConditionsPage';
import NotFoundPage from './pages/NotFoundPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App(){
  return(
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/icpp" element={<ImpureChessPrivacyPolicyPage />} />
        <Route path="/ictac" element={<ImpureChessTermsAndConditionsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
